import { Button } from './button';
import React from 'react';
import { observer } from 'mobx-react-lite';

interface VersionBannerProps {
    isVisible: boolean;
    hasUnsavedChanges: boolean;
    onRestore: () => void;
    onBackToLatest: () => void;
    onSaveChangesAsLatest: () => void;
    onDiscardChanges: () => void;
}

const VersionBanner: React.FC<VersionBannerProps> = observer(({
    isVisible,
    hasUnsavedChanges,
    onRestore,
    onBackToLatest,
    onSaveChangesAsLatest,
    onDiscardChanges
}) => {
    if (!isVisible) return null;

    if (hasUnsavedChanges) {
        return (
            <div className="bg-orange-50 border-b border-orange-200 px-4 py-2 flex items-center justify-between text-sm">
                <div className="flex flex-col">
                    <span className="font-medium text-orange-800">You have unsaved changes in a previous version</span>
                    <span className="text-orange-600">Save these changes as the latest version or discard them</span>
                </div>
                <div className="flex items-center gap-2">
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={onSaveChangesAsLatest}
                        className="h-7 px-3 text-xs font-medium bg-white border-orange-300 text-orange-800 hover:bg-orange-50"
                    >
                        Save as latest version
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={onDiscardChanges}
                        className="h-7 px-3 text-xs font-medium bg-white border-orange-300 text-orange-800 hover:bg-orange-50"
                    >
                        Discard changes
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between text-sm">
            <div className="flex flex-col">
                <span className="font-medium text-amber-800">You are viewing a previous version</span>
                <span className="text-amber-600">Restore this version to make edits</span>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={onRestore}
                    className="h-7 px-3 text-xs font-medium bg-white border-amber-300 text-amber-800 hover:bg-amber-50"
                >
                    Restore this version
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={onBackToLatest}
                    className="h-7 px-3 text-xs font-medium bg-white border-amber-300 text-amber-800 hover:bg-amber-50"
                >
                    Back to latest version
                </Button>
            </div>
        </div>
    );
});

export default VersionBanner;